<template>
  <section class="">
    <div class="d-md-flex justify-content-between align-items-center">
      <div v-for="(stat, i) in otherStatistics"
        :key="i"
        :class="stat.customClass"
      >
        <div class="d-flex align-items-center flex-wrap flex-column">
          <div>
            <h1 class="m-0 p-0 font-weight-bold" :class="stat.color">
              {{ stat.value }}
            </h1>
          </div>
          
          <div class="">
            <p class="m-0 ">
              {{ stat.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserIcons from "@/pages/main/home/UserIcons.vue";
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    UserIcons,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    otherStatistics: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ""
    }
  },
}
</script>


<style lang="scss">

p {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 3px !important;
}

.other-stat-card {
  border-radius: 10px;
  margin-left: 10px;
}



.dark-layout {

  .users {
    .icon-card {

      background-color: #404A5B;
    }
  }
  .verified {
    .icon-card {
      background-color: #6A7580;
    }
  }

  .unverified {
    .icon-card {
      background-color: #72717E;
    }
  }

  .subscriptions {
    .icon-card {
      //background-color: rgb(214, 251, 255, 0.30);
      background-color: #5D6E7D;
    }
  }

}

</style>
